// Browser-only pending markers are not durable domain data.
const stable=value=>JSON.stringify(value,(_key,v)=>v&&typeof v==='object'&&!Array.isArray(v)?Object.fromEntries(Object.entries(v).sort(([a],[b])=>a.localeCompare(b))):v);
const cleanItem=item=>{const copy={...item};delete copy.syncPending;delete copy.syncBase;return copy;};
function entries(workspace){
 const result=[];
 for(const type of ['clients','copies','chats'])for(const item of workspace[type]||[])result.push({key:JSON.stringify([type,type==='clients'?item.id:item.client,String(item.id)]),item});
 for(const [clientId,list] of Object.entries(workspace.tasks||{}))for(const item of list)result.push({key:JSON.stringify(['tasks',clientId,String(item.id)]),item});
 return result;
}
export function workspaceSnapshot(workspace){
 const snapshot=structuredClone(workspace);
 delete snapshot.activeClient;
 for(const {item} of entries(snapshot)){delete item.syncPending;delete item.syncBase;}
 return snapshot;
}
export function acknowledgeWorkspaceSnapshot(workspace,snapshot){
 const acknowledged=new Map(entries(snapshot).map(({key,item})=>[key,stable(cleanItem(item))]));
 for(const {key,item} of entries(workspace)){
  if(item.syncPending===true&&acknowledged.get(key)===stable(cleanItem(item))){delete item.syncPending;delete item.syncBase;}
 }
}
